import React from 'react'
import styled from 'styled-components'
import { Tooltip } from '../../common'
import { Pair } from '../../model'
import { Pool } from '../../providers/apiPools/model'
import { bigNumber18DecimalsToDollars } from '../../utils'

interface Props {
  pair?: Pair
  apiPool?: Pool
}

export function TotalValueLockedTooltip({ pair, apiPool }: Props) {
  return (
    <Tooltip>
      <p>Total Value Locked in USD.</p>
      <Table>
        <tbody>
          <tr>
            <th>{pair ? pair.getToken0Symbol() : '-'} Value</th>
            <td>{apiPool ? bigNumber18DecimalsToDollars(apiPool.tokenAValue) : '-'}</td>
          </tr>
          <tr>
            <th>{pair ? pair.getToken1Symbol() : '-'} Value</th>
            <td>{apiPool ? bigNumber18DecimalsToDollars(apiPool.tokenBValue) : '-'}</td>
          </tr>
          <tr>
            <th>Total Value</th>
            <td>{apiPool ? bigNumber18DecimalsToDollars(apiPool.totalTokenValue) : '-'}</td>
          </tr>
        </tbody>
      </Table>
    </Tooltip>
  )
}

const Table = styled.table`
  th {
    text-align: left;
  }
`
